import { render } from "./AdminNav.vue?vue&type=template&id=67006751"
import script from "./AdminNav.vue?vue&type=script&lang=js"
export * from "./AdminNav.vue?vue&type=script&lang=js"

import "./AdminNav.vue?vue&type=style&index=0&id=67006751&lang=css"
script.render = render

export default script